module.exports = __webpack_public_path__ + "static/ava-149f6ae5b4e707ffb13fec5b96ac992a.png";